import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { faqItems } from "../lib/content";

export const FAQ = () => (
    <section className="border-t border-foreground py-16 sm:py-24" data-testid="faq-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10">
            <div className="editorial-label mb-3">Frequently asked</div>
            <h2 className="text-4xl sm:text-5xl font-black tracking-tighter mb-12">
                Questions we get a lot.
            </h2>
            <Accordion type="single" collapsible className="border-t border-foreground" data-testid="faq-accordion">
                {faqItems.map((item, i) => (
                    <AccordionItem
                        key={i}
                        value={`item-${i}`}
                        className="border-b border-foreground"
                        data-testid={`faq-item-${i}`}
                    >
                        <AccordionTrigger className="text-lg sm:text-xl font-bold py-6 hover:text-primary hover:no-underline tracking-tight text-left">
                            {item.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-base text-foreground/80 leading-relaxed pb-6">
                            {item.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    </section>
);
